import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=1c731c47&scoped=true&"
import script from "./ProductsDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=1c731c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c731c47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VContainer,VDivider,VRow})
